import * as Yup from "yup";


export interface IBankAccountModel {
  id: number | null;
  accountName: string;
  currency: string;
  operationBranch: string;
  active: boolean;
  giftCheckAccount: boolean;
  bankName: string;
  branchName: string;
  specialCode: string;
  email: string;
}

export const initialBankAccount: IBankAccountModel = {
  id: null,
  accountName: "",
  currency: "",
  operationBranch: "",
  active: false,
  giftCheckAccount: false,
  bankName: "",
  branchName: "",
  specialCode: "",
  email: "",
};


export const bankAccountValidation = Yup.object().shape({
  accountName: Yup.string()
    .trim()
    .required("Hesap adı zorunludur"),
  currency: Yup.string()
    .trim()
    .notRequired(),
  operationBranch: Yup.string()
    .trim()
    .notRequired(),
  active: Yup.boolean()
    .required("Aktif bilgisi zorunludur"),
  giftCheckAccount: Yup.boolean()
    .required("Hediye çek hesabı bilgisi zorunludur"),
  bankName: Yup.string()
    .trim()
    .notRequired(),
  branchName: Yup.string()
    .trim()
    .notRequired(),
  specialCode: Yup.string()
    .trim()
    .notRequired(),
  email: Yup.string()
    .trim()
    .transform((v, o) => (o === "" ? undefined : v))
    .email("Geçerli bir e-posta adresi giriniz")
    .notRequired(),
});
